import theme from './theme';

export {default as pallete} from './pallete';
export default theme;